import React, {useState } from 'react';
import './Docs.css'
import DocsSidebar from '../Components/Docs/DocsSidebar'
import Introduction from '../Sections/Docs/Introduction'
import DeveloperSupport from '../Sections/Docs/DeveloperSupport'
import Authentication from '../Sections/Docs/Authentication';
import RateLimits from '../Sections/Docs/RateLimits';

function Docs() {

    const [isVisible, setIsVisible] = useState("");

    return (
        <div id='docs_email_spam'>
            <DocsSidebar isVisible={isVisible}/>
            <Introduction setIsVisible={setIsVisible}/>
            <DeveloperSupport setIsVisible={setIsVisible}/>
            <Authentication setIsVisible={setIsVisible}/>
            <RateLimits setIsVisible={setIsVisible}/>
        </div>
    )
}

export default Docs
